
import * as React from "react";

import {cs} from "@Common/react/chain-services";

import "./color-picker.scss";
import {NoColorSvg} from "@Common/ui-components/image-editor/modes/filter-mode/tint-modal/hue-selector/color-picker/no-color-svg";
import {UseState} from "@Common/react/use-state";
import {cx} from "emotion";

export const ColorPicker = ({state, next}) => cs(
    ["opened", (_, next) => UseState({next})],
    ({opened}) => next({
        opened: opened.value,
        renderToggle: () => (
            <div {...{
                className: cx("color-picker-8rd toggle", {opened: opened.value}),
                onClick: () => opened.change(v=>!v),
            }}>
                <div className="color-box" style={{backgroundColor: state.value}}>
                    {state.value == null && NoColorSvg({size: 19})}
                </div>
                <div className="dropdown-indicator">
                    {/*<i className="fa fa-caret-down"/>*/}
                    <i className={cx("fa fa-caret-" + (opened.value ? "up" : "down"))}/>
                </div>

            </div>
        ),
        
        renderPalette: () => opened.value && (
            <div className="color-picker-8rd palette">
                {colorRows.map((row, i) => (
                    <div className="row" key={i}>
                        {row.map((color, j) => (
                            <div {...{
                                className: cx("color", {selected: state.value == color}),
                                key: j,
                                style: {backgroundColor: color},
                                onClick: () => state.onChange(color),
                            }}>
                                {color == null && (
                                    NoColorSvg({size: 25})
                                )}
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        ),
    }),
);

const colorRows = [
    [     null, "#000000", "#FFFFFF", "#FF8A80", "#E76A20"],
    ["#7F93FF", "#80D8FF", "#FF0001", "#6520FF", "#0091EA"],
    ["#00C853", "#FFBA02", "#FF6D00", "#DD2C00", "#795548"],
    ["#01685C", "#00887A", "#4CB6AC", "#307C32", "#43A047"],
    ["#EB407A", "#AC1457", "#6A1B9A", "#AC48BF", "#9F8DA2"],
];
